module.exports = __webpack_public_path__ + "static/img/icon_video3.b0e1836.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_video3.jpg
// module id = fzdL
// module chunks = 21